export class AuthLocationStorage {
    constructor(localStorage) {
        this.localStorage = localStorage;
    }
    storeLocation(location) {
        this.localStorage.setItem('afterLoginPath', location);
    }
    get afterLoginPath() {
        return this.localStorage.getItem('afterLoginPath') || '/';
    }
}
//# sourceMappingURL=location.storage.js.map